SettingEditCtrl = ($scope, $filter, flash, setting, AppSettingAPIService, PaymentService) ->
  $scope.setting = setting

  $scope.submit = (setting) ->
    AppSettingAPIService.update(setting).then ->
      flash.success $filter('translate')('API_SUCCESS')

  $scope.cancelPayment = ->
    PaymentService.openCancelModal()

SettingEditCtrl['$inject'] = [
  '$scope'
  '$filter'
  'flash'
  'setting'
  'AppSettingAPIService'
  'PaymentService'
]

module.exports = SettingEditCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/setting/edit-controller.coffee